interface Testimonial {
  name: string;
  quote: string;
}

interface TestimonialsStripProps {
  testimonials?: Testimonial[];
  title?: string;
  subtitle?: string;
}

const defaultTestimonials = [
  {
    name: "Simona",
    quote:
      "Nusipirkau „Semčiukų\" seriją savo 5 metukų mažai. Kiekvieną vakarą prieš miegą klausome „Labas vakaras\". Pirmą kartą išgirdusi paklausė: „Mama, o semčiukai tikri?\" Aš net nežinojau ką atsakyti 😂 Rekomenduoju visoms mamoms.",
  },
  {
    name: "Edita R.",
    quote:
      "Ačiū, Rimante. „Laiminga knyga\" pakeitė mano požiūrį į save. Perskaičiau per savaitę, dabar jau antrą kartą skaitau. Yra moterys, kurios supranta, o yra Rimantė — kuri pasako tiesiai, be jokių gražių apėjimų. Tokių knygų Lietuvoje labai reikia.",
  },
  {
    name: "Monika V.",
    quote:
      "Jau trečią pamoką perku. Pirmą — „Pasakyti ir nesusipykti\" — klausėmės su vyru ilgoje kelionėje į Palangą. Ir pirmą kartą per daugybę metų normaliai pasikalbėjome apie sunkius dalykus. Kaip jums pavyksta taip paprastai paaiškinti tai, kas atrodė neįmanoma? Laukiu naujų labai.",
  },
  {
    name: "Vilma",
    quote:
      "Užsakiau dienoraštį „Tu man\". Knyga labai graži. Jau savaitę rašome su vyru (jis iš pradžių spyresis, o dabar pats vakarais ieško). Ačiū, kad padarėte. Mums to labai reikėjo, labai laiku ❤️",
  },
];

const TestimonialsStrip = ({
  testimonials = defaultTestimonials,
  title = "Ką sako laimingi žmonės",
  subtitle = "— Atsiliepimai —",
}: TestimonialsStripProps) => {
  return (
    <section className="bg-cream-soft py-20 border-t border-ink/5">
      <div className="container mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-[11px] tracking-[0.22em] uppercase text-ink/55 font-semibold">
            {subtitle}
          </span>
          <h2 className="font-marquee text-3xl md:text-5xl font-bold text-ink mt-3">
            {title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="bg-cream rounded-2xl p-7 md:p-9 border border-ink/5 shadow-sm flex flex-col"
            >
              <blockquote className="text-ink/80 text-base md:text-[17px] leading-relaxed italic whitespace-pre-line flex-1">
                {t.quote}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-ink/10">
                <span className="font-marquee text-xl text-terracotta font-bold">
                  {t.name}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsStrip;
